import { BookkeepingTag, BookkeepingTagCategory } from '../types/bookkeepingTag'

export const isBookkeepingTagCategory = (
  item: BookkeepingTag | BookkeepingTagCategory,
): item is BookkeepingTagCategory => {
  return 'question' in item
}
